import { newE2EPage } from "@stencil/core/testing";
import { testValidHtml } from "../../../test-utils/html-validate";

describe("Direct Searchbox", () => {
    it("should render a component", async () => {
        const page = await newE2EPage();
        await page.setContent(`<ux-direct-searchbox></ux-direct-searchbox>`);
        const el = await page.find("ux-direct-searchbox");
        await page.waitForChanges();
        expect(el).toHaveClass("hydrated");
    });

    it("should match snapshot", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-direct-searchbox url="/test-api" placeholder="Test Placeholder" button-text="Test Button Label">
                  </ux-direct-searchbox>`
        );
        const el = await page.find("ux-direct-searchbox");
        await page.waitForTimeout(500);
        await page.waitForChanges();
        expect(el).toMatchSnapshot();
    });

    it("should send request and display error", async () => {
        const page = await newE2EPage();
        await page.setContent(
            `<ux-direct-searchbox url="/test-api" placeholder="Test Placeholder" button-text="Test Button Label"
                  </ux-direct-searchbox>`
        );

        // const el = await page.find("ux-direct-searchbox");
        await page.waitForChanges();

        const input = await page.find("ux-direct-searchbox input[type=text]");
        const submitButton = await page.find("ux-direct-searchbox button[type=submit]");

        expect(submitButton).toEqualText("Test Button Label");
        let value = await input.getProperty("value");
        expect(value).toBe("");
        await input.press("a");
        value = await input.getProperty("value");
        expect(value).toBe("a");
        //await submitButton.click();
        //await page.waitForChanges();
        //expect(el).toMatchSnapshot();
    });

    it("should render valid html", async () => {
        await testValidHtml(
            `<ux-direct-searchbox url="/test-api" placeholder="Test Placeholder"
                                       button-text="Test Button Label"></ux-direct-searchbox>`
        );
    });
});
